import _classCallCheck from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * This object represents a custom listener.
 * @typedef {Object} Listener
 * @property {String} Listener.eventName - The listener name.
 * @property {Function} Listener.callback - The listener callback function.
 */
var Listeners = /*#__PURE__*/function () {
  /**
   * @classdesc
   * This class represents a custom listeners manager.
   * @constructs
   */
  function Listeners() {
    _classCallCheck(this, Listeners);

    /**
     * Array containing all custom listeners.
     * @type {Object[]}
     */
    this.listeners = [];
  }
  /**
   * Add a listener to Listener class.
   * @param {Object} listener - A listener object.
   */


  _createClass(Listeners, [{
    key: "add",
    value: function add(listener) {
      this.listeners.push(listener);
    }
    /**
     * Fires MathType event listeners
     * @param {String} eventName - event name
     * @param {Event} event - event object.
     * @return {boolean} false if event has been prevented. true otherwise.
     */

  }, {
    key: "fire",
    value: function fire(eventName, event) {
      for (var i = 0; i < this.listeners.length && !event.cancelled; i += 1) {
        if (this.listeners[i].eventName === eventName) {
          // Calling listener.
          this.listeners[i].callback(event);
        }
      }

      return event.defaultPrevented;
    }
    /**
     * Creates a new listener object.
     * @param {string} eventName - Event name.
     * @param {Object} callback - Callback function.
     * @returns {object} the listener object.
     */

  }], [{
    key: "newListener",
    value: function newListener(eventName, callback) {
      var listener = {};
      listener.eventName = eventName;
      listener.callback = callback;
      return listener;
    }
  }]);

  return Listeners;
}();

export { Listeners as default };